import { Box, DropdownLayoutOption, Loader, Text } from '@wix/design-system';
import React, { ReactNode } from 'react';
import { CollectionState, FiltersMap } from '@wix/bex-core';

export interface UsePlaceholderStateOptionsParams<T, F extends FiltersMap> {
  collection: CollectionState<T, F>;
  fixedFooter?: ReactNode;
}

export function usePlaceholderStateOptions<T, F extends FiltersMap>(
  options: DropdownLayoutOption[],
  params: UsePlaceholderStateOptionsParams<T, F>,
): {
  fixedFooter?: ReactNode;
  options: DropdownLayoutOption[];
  showInitialLoader?: boolean;
} {
  const { collection } = params;
  const { translate: t } = collection;

  const getEmptyStateText = () =>
    collection.hasAvailableItems
      ? t('cairo.dropdownSearch.filters.noResults')
      : t('cairo.dropdownSearch.filters.emptyState');

  if (collection.showInitialLoader || collection.result.status.isLoading) {
    return {
      showInitialLoader: true,
      fixedFooter: (
        <Box
          dataHook="initial-loader"
          width="100%"
          align="center"
          verticalAlign="middle"
          padding="SP2"
        >
          <Loader size="small" />
        </Box>
      ),
      options,
    };
  }

  if (collection.showEmptyState) {
    return {
      fixedFooter: (
        <Box
          dataHook="empty-state"
          width="100%"
          verticalAlign="middle"
          padding="SP2"
        >
          <Text dataHook="empty-state-text" secondary light>
            {getEmptyStateText()}
          </Text>
        </Box>
      ),
      options,
    };
  }

  return {
    options,
    fixedFooter: params.fixedFooter,
  };
}
